<!--
 * @FileDescription: 卡片模板（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-15（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-15（最后更新时间）
 -->
<template>
    <div class="card-temp1">
        <div  class="account-li"  @mouseover="mouseOver()"  @mouseleave="mouseLeave()" >
            <div  class="account-li-content" >
                <template v-if="isDelete">
                    <img src="@/assets/image/close@2x.png" class="account-li-close" v-show="isShow" @click="onDelete()"/>
                </template>
                <slot></slot>
            </div>
        </div>
        <a-modal :title="title" v-model="visible" @ok="handleOk" class="cancel-out-model1">
            <div class="cancel-out-image1">
                <img src="@/assets/image/tishi.png" alt="" class="image">
                您是否确定要删除？
            </div>
        </a-modal>
    </div>
</template>
<script>
    export default {
        props:{
            width:{
                type:Number,
                default:494
            },
            height:{
                type:Number,
                default: 200
            },
            index:{
                type:Number
            },
            id:{
                type:String
            },
            title:{
                type:String,
                default:'删除'
            },
            isDelete:{
                type:Boolean,
                default:true
            }
        },
        data() {
            return {
                isShow:false,
                visible:false,
            }
        },
        mounted(){
        },
        methods: {
            /**
             * @description: 移入（方法描述）
             */
            mouseOver(){
                this.isShow = true
            },
            /**
             * @description: 移除（方法描述）
             */
            mouseLeave(){
                this.isShow = false
            },
            /**
             * @description: 删除（方法描述）
             */
            onDelete(){
                this.visible = true
            },
            handleOk(){
                this.visible = false
                this.$emit('onDelete',this.index,this.id)
            }

        },
        components:{


        },
        watch:{

        },
        created(){

        }
    }
</script>
<style lang="scss">
    .card-temp1{
        .account-li{
            width: 474px;
            height: 280px;
        }
        .account-li-content{
            width: 494px;
            height: 290px;
        }
    }
     .cancel-out-model1{
        width: 400px !important;
        height: 270px !important;
    }
</style>
<style scoped lang="scss">
    .cancel-out-image1{
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            width: 24px !important;
            height: 24px !important;
            margin-right: 16px !important;
        }
    }
</style>
